var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"Add New Tag","visible":_vm.visible,"confirmLoading":_vm.isSubmitting,"okText":"Create","cancelText":"Cancel"},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('a-form',{attrs:{"form":_vm.tagForm},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',{attrs:{"label":"Tag Name"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'name',
          {
            rules: [
              {
                required: true,
                message: 'Please input Tag Name!'
              }
            ]
          }
        ]),expression:"[\n          'name',\n          {\n            rules: [\n              {\n                required: true,\n                message: 'Please input Tag Name!'\n              }\n            ]\n          }\n        ]"}],attrs:{"placeholder":"Enter tag name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }